module.exports = __webpack_public_path__ + "static/media/icon-download.00563b77.svg";